// Shared layout for the three legal/policy pages. Renders a scrollable dark
// container with a title, an "Effective" date, and any children (JSX blocks
// with headings). Also exposes a "Back" button that calls onBack() so the
// page hooks into whatever navigation model the caller uses (currentPage
// state in App.js, or window.history for the login-page overlay).
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function LegalPageLayout({ title, effective, onBack, children }) {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <div className="max-w-3xl mx-auto px-6 py-10">
        {onBack && (
          <Button
            variant="ghost"
            onClick={onBack}
            className="text-slate-400 hover:text-slate-100 mb-6 -ml-3"
            data-testid="legal-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-1.5" /> Back
          </Button>
        )}
        <h1 className="text-3xl font-semibold text-white mb-2">{title}</h1>
        <p className="text-slate-500 text-sm mb-8">
          Effective {effective} · AeroGuard Aviation Safety Management System
        </p>
        <article className="prose prose-invert prose-slate max-w-none space-y-6 leading-relaxed">
          {children}
        </article>
      </div>
    </div>
  );
}
